// extracted by mini-css-extract-plugin
export default {"line":"_4xdALFVr9gRcTFJLJe8Qj","file":"_3r2BWrwFrhOSrp3nZVxSKY","argument":"xvrLcuM3FujAjj8tOFpPD"};